import { Button, Group, Radio, Text, Textarea, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { reasonCause } from '../../../config/Constant';
import { ROUTES } from '../../../config/RoutesName';
import { buttonStyle } from '../../../utils/styles/GlobalStyle';
import { singleRadioButton, useOrderStyle, useRadiorStyle, useWebOrderStyle, useWebRadiorStyle } from '../style';
import { cancelOrder, formData } from '../../../services/order/order.service';
import { toastError, toastSuccess } from '../../../config/Helper';
import { AxiosResponse, isAxiosError } from 'axios';
import { IBaseResponseError } from '../../../typescript/interfaces/common.interface';

const CancelReason = ({ modalClose }: any) => {
  const { classes: radioClasses } = useRadiorStyle();
  const theme = useMantineTheme();
  const mobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  const { classes: webRadioClasses } = useWebRadiorStyle();
  const { classes: radioButton } = singleRadioButton();
  const { classes } = useOrderStyle();
  const { classes: buttonClass } = buttonStyle();
  const { classes: webOrderStyle } = useWebOrderStyle();
  const navigate = useNavigate();
  const { orderId } = useParams<{ orderId: string }>();
  const [reason, setReason] = useState<string>('0');
  const [reasonComment, setReasonComment] = useState('');

  const submitCancelReason = async () => {
    const formData: formData = {
      reason: reason,
    };

    if (reason === '7') formData.comment = reasonComment;

    try {
      const data = await cancelOrder(orderId, formData);
      if (data.success) {
        toastSuccess(data.message);
        modalClose();
        navigate(ROUTES.CART, { replace: true });
      }
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        const response = error.response as AxiosResponse<IBaseResponseError> | undefined;
        const data = response?.data;
        const hasApiError = data?.data?.error_type && data?.data?.error_message;
        // toastError(hasApiError ? data : data?.message);
      }
      modalClose();
    }
  };

  return (
    <>
      <Text fz={mobile ? '11px' : '13px'} color='black' fw={500} pt='10px'>
        Please mention the reason for cancel the order
      </Text>
      <Radio.Group
        name='cancelReason'
        label='Reason'
        onChange={setReason}
        value={reason}
        classNames={mobile ? radioClasses : webRadioClasses}>
        <Group mt='xs' display='flex' pl={'10px'} className={classes.radioOption}>
          {reasonCause.length > 0 &&
            reasonCause.map((data: any, id: number) => (
              <Radio
                color={'orange'}
                classNames={radioButton}
                key={id}
                fw={450}
                value={data.value}
                label={data.label}
              />
            ))}
        </Group>
      </Radio.Group>
      {reason === '7' && (
        <Textarea
          placeholder='Type in within 100 words'
          label='Reason'
          autosize
          minRows={5}
          pt={'md'}
          classNames={mobile ? classes : webOrderStyle}
          onChange={(e) => {
            setReasonComment(e.target.value);
          }}
        />
      )}

      <Group pt={'15px'} position='center'>
        <Button
          onClick={submitCancelReason}
          className={buttonClass.buttonShadow}
          size='xl'
          px={50}
          fz={'16px'}
          color='red'
          radius={'11px'}>
          Submit
        </Button>
      </Group>
    </>
  );
};

export default CancelReason;
